import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "color1", "color2", "title", "name", "qr", "barcode", "preview", "previewColor1", "previewColor2", "previewTitle", "previewName", "previewQR", "previewBarcode", "previewNFC" ]

  updateTitle() {
    this.previewTitleTarget.textContent = this.titleTarget.value
  }

  updateName() {
    this.previewNameTarget.textContent = this.nameTarget.value
  }

  updateColor1() {
    this.previewTarget.style.backgroundColor = this.color1Target.value
    this.previewColor1Target.textContent = this.color1Target.value
  }

  updateColor2() {
    this.previewTarget.style.color = this.color2Target.value
    this.previewColor2Target.textContent = this.color2Target.value
  }

  toggleQR() {
    this.barcodeTarget.checked = false
    this.previewBarcodeTarget.style.display = 'none';
    this.previewQRTarget.style.display = this.qrTarget.checked ? 'block' : 'none';
    this.previewNFCTarget.style.display = (this.qrTarget.checked || this.barcodeTarget.checked) ? 'none' : 'block';
  }

  toggleBarcode() {
    this.qrTarget.checked = false
    this.previewQRTarget.style.display = 'none';
    this.previewBarcodeTarget.style.display = this.barcodeTarget.checked ? 'block' : 'none';
    this.previewNFCTarget.style.display = (this.qrTarget.checked || this.barcodeTarget.checked) ? 'none' : 'block';
  }

}
